import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import styles from './NoData.module.scss'

const cx = classNames.bind(styles)

const NoData = ({ noDataText }) => {
  return (
    <div className={cx('no-data')} >
      <div className={cx('no-data-label')} >
        {noDataText}
      </div>
    </div>
  )
}

NoData.propTypes = {
  noDataText: PropTypes.string.isRequired,
}

NoData.defaultProps = {
  noDataText: ''
}

export { NoData }
